import src from "IMAGE";
export default { src, width: 231, height: 70, blurWidth: 0, blurHeight: 0};
